// extracted by mini-css-extract-plugin
module.exports = {"title":"QuestionsAnswersAccordion_title__w_OMU"};